// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"R0-z"};